const SanteTypeGarantie = {
  HOSPITALISATION: '2',
  COMPLETE: '1',
}
Object.freeze(SanteTypeGarantie)

export { SanteTypeGarantie }
